/* ==========================================================================
   Assistant MTA — widget frontend
   Saison 2026-2027

   SECURITE : ce fichier ne contient AUCUNE cle API et ne doit jamais en contenir.
   - Si un endpoint backend est configure : les questions y sont envoyees, la cle
     restant cote serveur.
   - Sinon : mode "FAQ locale", qui repond hors ligne a partir de la base de
     connaissance publique. Le widget reste donc toujours utile et jamais casse.

   28/08/2026 — REBRANCHE sur l'agent du CRM (/v1/site-agent/message) : l'ancien
   backend (mta-ai-assistant.onrender.com) servait une copie PERIMEE de la KB
   (constate en production : « le protege-dents n'est pas requis », l'inverse de
   la regle de securite du club, et aucune connaissance de la reservation en
   ligne). L'agent du CRM lit la KB vivante, cite ses sources, et sait capturer
   un prospect. Protocole : { sessionId, message, state } -> { reply, newState }.
   L'ancien protocole { message, history } -> { reply } reste tolere par le code
   ci-dessous (champs surnumeraires ignores par les deux serveurs).
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-mta-chat-config]');
  var panel = document.getElementById('mta-chat-panel');
  var launcher = document.querySelector('[data-mta-chat-open]');
  if (!cfgEl || !panel || !launcher) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var log = panel.querySelector('[data-mta-chat-log]');
  var form = panel.querySelector('[data-mta-chat-form]');
  var input = form.querySelector('input');
  var sendBtn = form.querySelector('[data-mta-chat-send]');
  var closeBtn = panel.querySelector('[data-mta-chat-close]');
  var suggWrap = panel.querySelector('[data-mta-chat-sugg]');

  var TEL = cfg.telephone || '06 14 47 09 26';
  var kb = null;
  var history = [];
  var state = {};
  var sessionId = (function () {
    try {
      var k = 'mtaChatSession';
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : 'web-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) {
      return 'web-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }
  })();
  var busy = false;
  var greeted = false;
  var lastFocus = null;

  /* ---------- rendu ---------- */

  function add(text, kind) {
    var el = document.createElement('div');
    el.className = 'mta-msg mta-msg-' + (kind || 'bot');
    el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function setBusy(v) {
    busy = v;
    sendBtn.disabled = v;
    sendBtn.textContent = v ? '…' : 'Envoyer';
  }

  /* ---------- ouverture / fermeture ---------- */

  function open() {
    lastFocus = document.activeElement;
    panel.hidden = false;
    launcher.hidden = true;
    if (!greeted) {
      greeted = true;
      add(cfg.accueil, 'bot');
      loadKb();
      loadFallback();
    }
    input.focus();
  }

  function close() {
    panel.hidden = true;
    launcher.hidden = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    else launcher.focus();
  }

  launcher.addEventListener('click', open);
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });

  /* Piege de focus simple : Tab reste dans le panneau quand il est ouvert */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || panel.hidden) return;
    var f = panel.querySelectorAll('button, input, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- base de connaissance ---------- */

  function loadKb() {
    if (kb || !cfg.kbUrl) return;
    fetch(cfg.kbUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { kb = d; })
      .catch(function () { kb = null; });
  }

  /* ---------- mode FAQ locale ----------
     Les reponses proviennent de mta-fallback.json, GENERE depuis la base de
     connaissance. Aucune donnee metier n'est dupliquee ici : une modification
     de tarif ou d'horaire se fait dans la KB puis se propage par regeneration. */

  var FB = null;

  function loadFallback() {
    if (FB || !cfg.fallbackUrl) return Promise.resolve();
    return fetch(cfg.fallbackUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) FB = d; })
      .catch(function () { FB = null; });
  }

  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function localAnswer(q) {
    if (!FB || !FB.regles) {
      return 'Je ne peux pas répondre pour le moment. Appelez le ' + TEL + ', le club vous renseignera directement.';
    }
    var n = norm(q);
    var best = null, bestScore = 0;
    FB.regles.forEach(function (r) {
      var score = 0;
      r.mots.forEach(function (kw) {
        var kn = norm(kw);
        if (n.indexOf(kn) !== -1) score += kn.length;
      });
      if (score > bestScore) { bestScore = score; best = r; }
    });
    return best ? best.reponse : (FB.defaut || 'Appelez le ' + TEL + '.');
  }

  /* ---------- envoi ---------- */

  function ask(q) {
    if (busy || !q.trim()) return;
    add(q, 'user');
    input.value = '';
    setBusy(true);

    if (!cfg.endpoint) {
      loadFallback().then(function () {
        add(localAnswer(q), 'bot');
        setBusy(false);
      });
      return;
    }

    var ctrl = new AbortController();
    var timer = window.setTimeout(function () { ctrl.abort(); }, 20000);

    fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sessionId, message: q, state: state, history: history.slice(-8) }),
      signal: ctrl.signal,
      credentials: 'omit'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var reply = (d && (d.reply || d.answer)) || '';
        if (!reply) throw new Error('empty');
        add(reply, 'bot');
        if (d && d.newState) state = d.newState;
        history.push({ role: 'user', content: q });
        history.push({ role: 'assistant', content: reply });
      })
      .catch(function () {
        // Repli silencieux et utile : on repond quand meme avec la FAQ locale.
        return loadFallback().then(function () {
          add(localAnswer(q), 'bot');
          add('Réponse hors ligne. Pour une confirmation, appelez le ' + TEL + '.', 'err');
        });
      })
      .then(function () {
        window.clearTimeout(timer);
        setBusy(false);
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ask(input.value);
  });

  if (suggWrap) {
    suggWrap.addEventListener('click', function (e) {
      if (e.target && e.target.tagName === 'BUTTON') ask(e.target.textContent);
    });
  }
})();
